import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLinkBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#5B8ADA"
      d="m18.38 9.437-2.99 2.991a5.528 5.528 0 0 1-7.818 0A1.185 1.185 0 1 1 9.24 10.76a3.178 3.178 0 0 0 4.472 0l2.99-2.99a3.162 3.162 0 1 0-4.471-4.473l-.948.958a1.187 1.187 0 0 1-1.678-1.678l.958-.958a5.528 5.528 0 1 1 7.818 7.818Zm-9.663 6.308-.948.958a3.162 3.162 0 1 1-4.472-4.472L6.288 9.24a3.179 3.179 0 0 1 4.472 0 1.185 1.185 0 0 0 1.668-1.668 5.519 5.519 0 0 0-7.818 0l-2.99 2.99a5.528 5.528 0 1 0 7.817 7.819l.958-.958a1.187 1.187 0 0 0-1.678-1.678Z"
    />
  </svg>
);
export default SvgLinkBlue;
